import { S as Splide } from './shared-import-splide.esm.bundle.js';
window.Splide = Splide;
window.slideshows = {};

function _prefetchAdjacentSlides(splide, range = 1) {
  const currentIndex = splide.index;
  const slides = splide.Components.Slides;
  const length = splide.length;

  for (let offset = 1; offset <= range; offset++) {
    [
      (currentIndex + offset) % length,
      (currentIndex - offset + length) % length
    ].forEach(idx => {
      const slideObj = slides.getAt(idx);
      if (!slideObj) return;
      slideObj.slide.querySelectorAll('img[loading="lazy"]').forEach(img => {
        if (img.complete) return;
        if (img.currentSrc) {
          new Image().src = img.currentSrc;
        } else if (img.src) {
          new Image().src = img.src;
        } else if (img.srcset) {
          const firstSrc = img.srcset.split(',')[0].trim().split(' ')[0];
          if (firstSrc) new Image().src = firstSrc;
        }
      });
    });
  }
}

const _createSplideInstance = (splideRoot, options, extensions) => {
  window.slideshows[splideRoot.id] = new Splide(`#${splideRoot.id}`, options);

  if (splideRoot.matches('.splide--product')) {
    if (!splideRoot.hasAttribute('data-thumbnails')) {
      document.addEventListener('cascade:product:thumbnailclick', e => {
        if (!e.target.contains(splideRoot)) return;
        const current_media_id = e.detail.current_media_id;
        const targetSlides = window.slideshows[splideRoot.id].Components.Slides.filter(slide => slide.slide.dataset.mediaId === current_media_id.toString());
        if (!targetSlides.length) return;
        window.slideshows[splideRoot.id].go(targetSlides[0].index);
      });
      window.slideshows[splideRoot.id].on('moved', newIndex => {
        const newMediaId = window.slideshows[splideRoot.id].Components.Slides.getAt(newIndex).slide.dataset.mediaId;
        const root = window.slideshows[splideRoot.id].Components.Slides.getAt(newIndex).slide.closest('[data-product-section]');

        if (root) {
          root.dispatchEvent(new CustomEvent('cascade:product:slidechange', {
            bubbles: true,
            detail: {
              current_media_id: newMediaId
            }
          }));
        }
      });
      window.slideshows[splideRoot.id].mount(extensions);
    } else {
      const thumbsRoot = document.getElementById(splideRoot.getAttribute('data-thumbnails'));
      window.slideshows[thumbsRoot.id] = new Splide(`#${thumbsRoot.id}`, {
        direction: 'ttb',
        height: 'var(--thumbnails-height)',
        autoHeight: true,
        arrows: false,
        pagination: false,
        isNavigation: true,
        gap: '1.25rem',
        slideFocus: false,
        wheel: true,
        wheelSleep: 200
      });
      window.slideshows[splideRoot.id] = new Splide(`#${splideRoot.id}`, options);
      const mainSplide = window.slideshows[splideRoot.id];
      const thumbsSplide = window.slideshows[thumbsRoot.id];
      mainSplide.sync(thumbsSplide);
      mainSplide.mount(extensions);
      thumbsSplide.mount();
    }
  } else {
    window.slideshows[splideRoot.id].mount(extensions);
  }

  // Prefetch adjacent slide images into browser cache
  const instance = window.slideshows[splideRoot.id];
  if (instance) {
    setTimeout(() => _prefetchAdjacentSlides(instance, 1), 100);
    instance.on('moved', () => {
      _prefetchAdjacentSlides(instance, 1);
    });
  }
};

window.destroySlideshow = splideRoot => {
  if (!window.slideshows[splideRoot.id]) return;
  window.slideshows[splideRoot.id].destroy(true);
  delete window.slideshows[splideRoot.id];
};

window.makeSlideshow = splideRoot => {
  // Thumbnails Splides’ initialization is started by their
  // main slideshow
  if (splideRoot.matches('.splide--thumbnails')) return;

  if (!splideRoot.id) {
    console.error('Cascade Theme: makeSlideshow requires a unique ID on the slideshow root');
    return;
  }

  if (window.slideshows[splideRoot.id]) return;
  const mobileOnly = splideRoot.matches('.splide--mobile-only'),
        desktopOnly = splideRoot.matches('.splide--desktop-only'),
        titlesOnTop = splideRoot.matches('.splide--titles-on-top');
  let breakpoints = {};

  if (mobileOnly) {
    breakpoints = {
      990: {
        destroy: true
      }
    };
  }

  const isRecommendations = splideRoot.closest && splideRoot.closest('.product-recommendations');
  const recommendationsSpeed = 280;

  if (!splideRoot.matches('.splide--product')) {
    if (!mobileOnly || desktopOnly) {
      if (isRecommendations) {
        breakpoints[990] = {
          perPage: 1,
          perMove: 1,
          speed: recommendationsSpeed,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        };
      } else if (!titlesOnTop) {
        breakpoints[990] = {
          perPage: 1,
          perMove: 1,
          speed: 520,
          // slightly less energetic than
          // var(--timing-func-energetic)
          easing: 'cubic-bezier(0.9,0.3,0.4,0.8)',
        };
      } else {
        breakpoints[990] = {
          perPage: 1,
          perMove: 1,
          speed: 720,
          // slightly less energetic than
          // var(--timing-func-energetic)
          easing: 'cubic-bezier(0.8,0.1,0.4,0.9)',
        };
      }

      if (desktopOnly) {
        breakpoints[0] = {
          destroy: true
        };
        breakpoints[990]['destroy'] = false;
      }
    }
  }

  if (splideRoot.matches('.splide--slideshow-section')) {
    breakpoints[990] = {
      speed: 720,
      // slightly less energetic than
      // var(--timing-func-energetic)
      easing: 'cubic-bezier(0.8,0.1,0.4,0.9)'
    };
  }

  const options = {
    mediaQuery: 'min',
    perPage: 1,
    perMove: 1,
    autoWidth: true,
    arrows: true,
    rewind: true,
    easing: isRecommendations ? 'cubic-bezier(0.4, 0, 0.2, 1)' : 'var(--timing-func-energetic)',
    speed: isRecommendations ? 280 : 520,
    ...(isRecommendations && { noDrag: '.splide--product-tile, .splide--product-tile *' }),
    breakpoints: breakpoints
  };

  if (splideRoot.matches('.splide--product-tile')) {
    const productTileOptions = {
      mediaQuery: 'min',
      perPage: 1,
      perMove: 1,
      autoWidth: true,
      arrows: false,
      rewind: true,
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      speed: 220,
      drag: splideRoot.dataset.dragDisabled !== 'true',
      dragMinThreshold: 8,
      snap: true,
      focus: 'center',
      flickPower: 350,
      swipePower: (offset, velocity) => {
        const power = Math.abs(offset) * velocity;
        return Math.min(power, 0.55);
      },
      breakpoints: {}
    };
    
    _createSplideInstance(splideRoot, productTileOptions, {});
  } else if (splideRoot.matches('.splide--product')) {
    let productSplideBreakpoints = {};

    if (splideRoot.hasAttribute('data-desktop-product-splide')) {
      if (splideRoot.dataset.desktopProductSplide === 'destroy') {
        productSplideBreakpoints = {
          768: {
            destroy: true
          }
        };
      } else if (splideRoot.dataset.desktopProductSplide === 'no-controls') {
        productSplideBreakpoints = {
          768: {
            arrows: false,
            pagination: false
          }
        };
      }
    } else {
      productSplideBreakpoints = {
        768: {
          arrows: true,
          pagination: false
        }
      };
    }

    if (splideRoot.hasAttribute('data-split-splide')) {
      productSplideBreakpoints = {
        768: {
          height: 'calc(100vh - var(--header-group-height, 0px))',
          arrows: true,
          pagination: false
        }
      };
    }

    const productOptions = {
      mediaQuery: 'min',
      perPage: 1,
      perMove: 1,
      autoWidth: true,
      arrows: true,
      rewind: true,
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      speed: 220,
      drag: splideRoot.dataset.dragDisabled !== 'true',
      dragMinThreshold: 8,
      snap: true,
      flickPower: 350,
      swipePower: (offset, velocity) => {
        const power = Math.abs(offset) * velocity;
        return Math.min(power, 0.55);
      },
      breakpoints: productSplideBreakpoints
    };
    import('./components-splide-product.bundle.js').then(_ref => {
      let {
        default: SplideProductModule,
        SplideProduct
      } = _ref;

      _createSplideInstance(splideRoot, productOptions, {
        SplideProduct
      });
    });
  } else {
    _createSplideInstance(splideRoot, options, {});
  }
};

window.discoverNewSlideshows = function () {
  let container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  container.querySelectorAll('.splide').forEach(splideRoot => {
    makeSlideshow(splideRoot, true);
  });
};

window.destroySlideshowsIn = function () {
  let container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  container.querySelectorAll('.splide').forEach(splideRoot => {
    destroySlideshow(splideRoot);
  });
};

window.refreshSlideshowsIn = function () {
  let container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  container.querySelectorAll('.splide').forEach(splideRoot => {
    refreshSlideshow(splideRoot);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  discoverNewSlideshows();
  
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('splide__pagination__page')) {
      e.stopPropagation();
      const linkElement = e.target.closest('a[href]');
      if (linkElement) {
        e.preventDefault();
      }
    }
  });

  
});
document.addEventListener('dev:hotreloadmutation', () => {
  if (!Shopify.designMode) {
    destroySlideshowsIn();
    discoverNewSlideshows();
  }
});
